<template>
  <li :class="[
    is_locked && !is_completed && !is_unlocked && (!is_demo || has_been_assigned) && can_open_contents_in_order ? 'locked' : '',
    (is_unlocked || is_demo) && !has_been_assigned ? 'unlocked' : '',
    is_completed ? 'completed' : '',
    is_current ? 'current' : '',
    is_unlocked ? 'active' : '',
    isAttemptBlocked ? 'attempt-blocked' : '',
    showAttemptBadge ? 'has-attempt-badge' : '',
  ]">
    <!-- Sınav hakkı: "Kalan hak: x/y". YALNIZCA sınırlı haklı sınavlarda
         gösterilir — sınırsızda rozet hiç basılmaz (bkz. showAttemptBadge).
         BILEREK <div>: ContentList.vue'nun `li > span` kurallari (mobilde
         `width: 100%`) rozeti bozuyordu, div o seciciye yakalanmiyor. -->
    <div v-if="showAttemptBadge"
      :class="['assignment-content-attempts', hasNoAttemptLeft ? 'assignment-content-attempts--blocked' : '']"
      :uk-tooltip="attemptTooltip">
      <i class="uil-redo"></i> {{ attemptText }}
    </div>

    <div class="icon-cat d-flex align-items-center"
      :style="categoryCursorStyle"
      @click.prevent="linkClick">
      <i :class="icon" class="mr-1"></i>{{ name }}
    </div>
    <a class="assignment-content-link" href="javascript:void(0)"
      :style="linkCursorStyle"
      @click.prevent="linkClick">
      <span class="assignment-content-title">
        {{ title }}
        <span v-if="contentItem?.pivot?.timed_content_type === 'timed_content'" class="assignment-content-dates">
          ({{ $t("general.start_date") }}: {{ contentItem.pivot.starts_at }}
          {{ $t("general.end_date") }}: {{ contentItem.pivot.ends_at }})
        </span>
      </span>
      <span v-if="contentInstructors.length" class="assignment-content-instructors">
        <span v-for="(instructor, index) in contentInstructors"
          :key="instructor.id || `content-instructor-${index}`"
          class="assignment-content-instructor"
          role="button"
          tabindex="0"
          @click.stop.prevent="$emit('instructor-click', instructor.raw)"
          @keydown.enter.stop.prevent="$emit('instructor-click', instructor.raw)"
          @keydown.space.stop.prevent="$emit('instructor-click', instructor.raw)">
          <i class="uil-user"></i>
          {{ instructor.name }}
        </span>
      </span>
    </a>
    <span>
      <!-- Yetkinlikler -->
      <div v-if="contentItem?.competencies && contentItem.competencies.length > 0" class="competencies-dropdown">
        <span class="competencies-badge">
          <i class="uil-award"></i> {{ $t('general.competencies_to_be_acquired') }} ({{ contentItem.competencies.length
          }})
          <i class="uil-angle-down dropdown-icon"></i>
        </span>
        <div class="competencies-list">
          <div v-for="competency in contentItem.competencies" :key="'competency_' + competency.id"
            class="competency-item">
            <span class="competency-name">{{ competency.name }}</span>
            <i v-if="competency.requires_approval" class="uil-check-circle approval-icon"></i>
          </div>
        </div>
      </div>

      <span class="uil-lock-alt"
        v-if="is_locked && !is_completed && !is_unlocked && !is_demo && can_open_contents_in_order"></span>
      <template v-if="is_completed"><i v-if="certificate_id" @click="$emit('show_certificate')"
          :uk-tooltip="'title:Tamamlama Sertifikası'" class="uil-award mr-1 cursor-pointer"></i><i
          class="uil-check-circle mr-1"></i></template>

      <template v-if="has_been_assigned && !(showAttemptBadge && !Number(point))">
        <span>
          <template v-if="contentItem?.file_category?.id === 12 && !is_completed">
            Geçme puanı :
          </template>

          {{ point | nullToZero }} {{ $t("point.point") }}
        </span>
      </template>
      <span v-if="!has_been_assigned && is_demo">Demo</span>
    </span>
  </li>
</template>

<script>
import Vue from 'vue';
Vue.filter('nullToZero', function (value) {
  if (!value) return 0

  return value;
});
export default {
  name: "ContentItem",
  props: {
    title: {
      required: true,
    },
    point: {
      required: true,
    },
    name: {
      required: true,
    },
    icon: {
      required: true,
    },
    is_completed: {
      required: false,
      default: false,
    },
    has_been_assigned: {
      required: false,
      default: true,
    },
    is_current: {
      required: false,
      default: false,
    },
    is_locked: {
      required: false,
      default: true,
    },
    is_unlocked: {
      required: false,
      default: false,
    },
    is_demo: {
      required: false,
      default: false,
    },
    certificate_id: {
      required: false,
      default: null,
    },
    can_open_contents_in_order: {
      required: false,
      default: null,
    },
    contentItem: {
      required: false,
      default: null,
    },
    /**
     * GET /api/assignment/:id -> exam_attempts[content_id].
     * { attempt_limit, attempts_used, remaining_attempts, can_start_exam }
     * Yalnizca sinav icerikleri icin dolu gelir; diger cagiran sayfalar
     * (EducationDetails, Dashboard vb.) gondermedigi icin default null.
     */
    attempt_info: {
      required: false,
      default: null,
    },
    /**
     * Atamanin `can_be_watched_again` degeri. Hak bitse de bu acikken sinav
     * GORUNTULEME icin acilabildigi icin satir tiklanabilir kalmali.
     */
    can_be_watched_again: {
      required: false,
      default: false,
    }
  },
  computed: {
    // Sira kilidi nedeniyle acilamiyor (mevcut davranis)
    isLockedForOrder() {
      return !!(this.is_locked && !this.is_demo && this.can_open_contents_in_order);
    },

    // Hak bitti -> rozet kirmizi. Satir yine de goruntuleme icin acik olabilir.
    // `=== false` BILEREK: alani henuz dondurmeyen bir backend'de rozet bozulmasin.
    hasNoAttemptLeft() {
      return this.attempt_info?.can_start_exam === false;
    },

    // Aksiyon tamamen kapali: hak bitti VE goruntuleme de acik degil
    isAttemptBlocked() {
      return this.hasNoAttemptLeft && !this.can_be_watched_again;
    },

    isActionDisabled() {
      return this.isLockedForOrder || this.isAttemptBlocked;
    },

    categoryCursorStyle() {
      return this.isActionDisabled ? 'cursor:no-drop' : 'cursor:pointer';
    },

    linkCursorStyle() {
      return this.isActionDisabled ? 'cursor:no-drop' : '';
    },

    // Sinirsiz hak. attempt_limit ve remaining_attempts'in ikisi de null gelir;
    // hangisi gelirse gelsin yakalanmasi icin ikisi de kontrol ediliyor.
    hasUnlimitedAttempts() {
      if (!this.attempt_info) return false;
      return this.attempt_info.attempt_limit === null || this.attempt_info.remaining_attempts === null;
    },

    /**
     * Sinirsiz hakta rozet GOSTERILMEZ: "Sinirsiz" yazisi liste satirinda
     * bilgi tasimiyor, yalnizca sinirli hakta "Kalan hak: x/y" anlamli.
     * `has-attempt-badge` (position: relative) de buna bagli — rozet
     * basilmadiginda satira gereksiz stil eklenmesin.
     */
    showAttemptBadge() {
      return !!this.attempt_info && !this.hasUnlimitedAttempts;
    },

    attemptText() {
      if (!this.attempt_info || this.hasUnlimitedAttempts) return '';

      const remaining = this.attempt_info.remaining_attempts ?? 0;
      return `${this.$t('general.remaining_attempts')}: ${remaining}/${this.attempt_info.attempt_limit}`;
    },

    attemptTooltip() {
      if (!this.attempt_info) return false;

      const used = `${this.$t('general.attempts_used')}: ${this.attempt_info.attempts_used ?? 0}`;
      if (this.hasNoAttemptLeft) {
        return `title:${used} — ${this.$t('general.no_remaining_attempt')}`;
      }
      if (this.hasUnlimitedAttempts) return `title:${used}`;

      return `title:${used} / ${this.$t('general.attempt_limit')}: ${this.attempt_info.attempt_limit}`;
    },

    contentInstructors() {
      if (!Array.isArray(this.contentItem?.instructors)) return [];

      return this.contentItem.instructors
        .map((instructor) => {
          const user = instructor?.user || {};
          const name =
            [user.name, user.surname].filter(Boolean).join(" ").trim() ||
            instructor?.full_name ||
            instructor?.name ||
            "";

          return {
            id: instructor?.id,
            name,
            raw: instructor,
          };
        })
        .filter((instructor) => instructor.name);
    },
  },
  methods: {
    linkClick() {
      if (this.is_locked && !this.is_completed && !this.is_unlocked && !this.is_demo && this.can_open_contents_in_order)
        return false;
      // Hak bitti ya da atama tarihleri uygun degil -> "Basla / Tekrar Gir" kapali
      if (this.isAttemptBlocked) return false;
      this.$emit("linkClick");
    },
  },
};
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}

.course-curriculum-list .active {
  background: #d6d7e8;
}

.icon-cat {
  color: white !important;
}

.icon-cat i {
  color: white !important;
}

.assignment-content-link {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.assignment-content-title {
  color: inherit;
  line-height: 1.4;
}

.assignment-content-dates {
  font-weight: 600;
}

.assignment-content-instructors {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.assignment-content-instructor {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  cursor: pointer;
}

.assignment-content-instructor:hover,
.assignment-content-instructor:focus-visible {
  border-color: #93c5fd;
  background: #dbeafe;
  outline: none;
}

.assignment-content-instructor i {
  color: inherit !important;
  font-size: 12px;
}

/* Sınav hakkı rozeti — satırın sağ üst köşesinde, yarısı üst kenarın dışında.
   `position: relative` yalnızca rozet varken ekleniyor ki bu komponenti kullanan
   diğer sayfalarda (EducationDetails, Dashboard) hiçbir şey değişmesin.
   Not: üst yarının kırpılmaması taşıyıcıların `overflow: visible` olmasına bağlı
   (ContentList.vue'da li/section/standalone için zaten tanımlı). */
li.has-attempt-badge {
  position: relative;
}

.assignment-content-attempts {
  position: absolute;
  top: 0;
  right: 12px;
  transform: translateY(-50%);
  z-index: 15;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #2563eb !important;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  cursor: default;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.assignment-content-attempts i {
  color: inherit !important;
  font-size: 12px;
}

.assignment-content-attempts--blocked {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626 !important;
}

/* Hakkı biten sınav satırı soluk görünür */
li.attempt-blocked > a,
li.attempt-blocked .assignment-content-title {
  color: #94a3b8;
}

li.attempt-blocked .icon-cat {
  background: #cbd5e1;
}

/* Competencies Dropdown Styles */
.competencies-dropdown {
  display: inline-block;
  margin-left: 8px;
  position: relative;
}

/* Parent li element overflow fix */
.course-curriculum-list>li {
  overflow: visible !important;
}

.competencies-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #f1f5f9 !important;
  color: #475569 !important;
  border: 1px solid #e2e8f0;
  box-shadow: none;
  transition: all 0.15s ease;
  font-weight: 500;
  cursor: pointer;
}

.competencies-badge:hover {
  background: #e2e8f0 !important;
}

.competencies-badge i {
  font-size: 12px;
  color: #64748b !important;
}

.dropdown-icon {
  font-size: 10px !important;
  color: #94a3b8 !important;
  transition: transform 0.2s ease;
  margin-left: 4px;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.competencies-list {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  max-width: 320px;
  z-index: 1000;
  margin-top: 6px;
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-6px);
  transition: all 0.15s ease;
}

.competencies-dropdown:hover .competencies-list {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.competency-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  transition: background 0.15s;
  border-left: 3px solid transparent;
}

.competency-item:hover {
  background: #f8fafc;
}

.competency-name {
  font-size: 13px;
  color: #475569;
  flex: 1;
  font-weight: 500;
  margin-left: 8px;
}

.approval-icon {
  color: #16a34a;
  font-size: 14px;
  background: rgba(22, 163, 74, 0.08);
  border-radius: 50%;
  padding: 2px;
}

/* Responsive — tablet */
@media (max-width: 768px) {
  .assignment-content-attempts {
    font-size: 10px;
    padding: 2px 6px;
    gap: 3px;
  }

  .competencies-badge {
    font-size: 10px;
    padding: 2px 6px;
    gap: 3px;
  }

  .competencies-badge i {
    font-size: 11px;
  }

  .competencies-list {
    min-width: 180px;
    max-width: 260px;
    right: 0;
  }

  .competency-item {
    padding: 6px 10px;
  }

  .competency-name {
    font-size: 12px;
    margin-left: 6px;
  }
}

/* Responsive — mobile */
@media (max-width: 480px) {
  .assignment-content-instructors {
    gap: 4px;
  }

  .assignment-content-instructor {
    padding: 2px 6px;
    font-size: 10px;
  }

  .assignment-content-attempts {
    font-size: 10px;
    padding: 2px 5px;
  }

  .competencies-dropdown {
    margin-left: 0;
  }

  .competencies-badge {
    font-size: 10px;
    padding: 2px 5px;
  }

  .competencies-badge .dropdown-icon {
    display: none;
  }

  .competencies-list {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    min-width: 100%;
    max-width: 100%;
    border-radius: 12px 12px 0 0;
    margin-top: 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    max-height: 50vh;
    overflow-y: auto;
    padding: 12px 0;
  }

  .competency-item {
    padding: 10px 16px;
  }

  .competency-name {
    font-size: 13px;
  }
}
</style>
